import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const isField = (el) => el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA") && el.type !== "file";

export function MobileHelpers() {
  const { pathname } = useLocation();

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  useEffect(() => {
    const onIn = (e) => isField(e.target) && document.body.classList.add("kb-open");
    const onOut = () => setTimeout(() => !isField(document.activeElement) && document.body.classList.remove("kb-open"), 50);
    const onKey = (e) => e.key === "Enter" && isField(e.target) && e.target.inputMode && e.target.blur();
    document.addEventListener("focusin", onIn);
    document.addEventListener("focusout", onOut);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("focusin", onIn);
      document.removeEventListener("focusout", onOut);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  return null;
}
